import React, { useState, useEffect } from 'react';
import './GroupRanking.css';

export default function GroupRanking() {
  const [activeTab, setActiveTab] = useState('latin');

  // Set page title
  useEffect(() => {
    document.title = 'Group Ranking | Greek Ranking';
  }, []);

  // Google Sheets URLs converted to embed format
  const sheets = {
    latin: 'https://docs.google.com/spreadsheets/d/1J64eMJDLbq9xBxbWOwCla40HcjZmiZ0dfwCAgo58tRw/edit?usp=sharing',
    contemporary: 'https://docs.google.com/spreadsheets/d/1UrSPTGPNBq9Y5oQJCbB1SumsdTfuaLAj91k7M66nhrA/edit?usp=sharing',
    hiphop: 'https://docs.google.com/spreadsheets/d/1pSPxdZ4JWqCk3AVJFPSTmPGgCvSEYrljPBqUaEdcZQI/edit?usp=sharing',
    commercial: '' // Commercial rankings starting from 2026 - sheet to be created
  };

  // Convert edit links to embed format for iframe
  const getEmbedUrl = (url) => {
    return url.replace('/edit?usp=sharing', '/pubhtml?widget=true&headers=false');
  };

  return (
    <div className="group-ranking-container">
      <div className="group-ranking-header">
        <h1>🏆 Group Ranking</h1>
        <p className="subtitle">View rankings for different dance categories</p>
      </div>

      {/* Tab Navigation */}
      <div className="group-ranking-tabs">
        <button
          className={`tab-button ${activeTab === 'latin' ? 'active' : ''}`}
          onClick={() => setActiveTab('latin')}
        >
          💃 Latin
        </button>
        <button
          className={`tab-button ${activeTab === 'contemporary' ? 'active' : ''}`}
          onClick={() => setActiveTab('contemporary')}
        >
          🎭 Contemporary
        </button>
        <button
          className={`tab-button ${activeTab === 'hiphop' ? 'active' : ''}`}
          onClick={() => setActiveTab('hiphop')}
        >
          🎤 Hip Hop
        </button>
        <button
          className={`tab-button ${activeTab === 'commercial' ? 'active' : ''}`}
          onClick={() => setActiveTab('commercial')}
        >
          🎬 Commercial
        </button>
      </div>

      {/* Tab Content */}
      <div className="group-ranking-content">
        {activeTab === 'latin' && (
          <div className="tab-panel-no-preview" key="latin">
            <div className="ranking-card">
              <h2>💃 Latin Rankings</h2>
              <p className="ranking-description">
                View the complete Latin group rankings in Google Sheets
              </p>
              <a 
                href={sheets.latin} 
                target="_blank" 
                rel="noopener noreferrer"
                className="open-sheet-btn-large"
              >
                📄 Open Ranking in Google Sheets
              </a>
            </div>
          </div>
        )}

        {activeTab === 'contemporary' && (
          <div className="tab-panel-no-preview" key="contemporary">
            <div className="ranking-card">
              <h2>🎭 Contemporary Rankings</h2>
              <p className="ranking-description">
                View the complete Contemporary group rankings in Google Sheets
              </p>
              <a 
                href={sheets.contemporary} 
                target="_blank" 
                rel="noopener noreferrer"
                className="open-sheet-btn-large"
              >
                📄 Open Ranking in Google Sheets
              </a>
            </div>
          </div>
        )}

        {activeTab === 'hiphop' && (
          <div className="tab-panel-no-preview" key="hiphop">
            <div className="ranking-card">
              <h2>🎤 Hip Hop Rankings</h2>
              <p className="ranking-description">
                View the complete Hip Hop group rankings in Google Sheets
              </p>
              <a 
                href={sheets.hiphop} 
                target="_blank" 
                rel="noopener noreferrer"
                className="open-sheet-btn-large"
              >
                📄 Open Ranking in Google Sheets
              </a>
            </div>
          </div>
        )}

        {activeTab === 'commercial' && (
          <div className="tab-panel-no-preview" key="commercial">
            <div className="ranking-card">
              <h2>🎬 Commercial Rankings</h2>
              <p className="ranking-description">
                Commercial rankings starting from 2026 season. Group ranking sheet coming soon!
              </p>
              {sheets.commercial ? (
                <a 
                  href={sheets.commercial} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="open-sheet-btn-large"
                >
                  📄 Open Ranking in Google Sheets
                </a>
              ) : (
                <p style={{ fontStyle: 'italic', color: '#888' }}>
                  Ranking sheet will be available once 2026 season begins.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
